import { TrendingUpRounded } from '@material-ui/icons';
import {
    INIT,
    RESET,
    SET_DISABLED,
   
} from './types';

export const initialStateDisabled={
    "mandante": {disabled:false, radio:false}, 
    "origenHono": {disabled:false, radio:false}, 
    "situacionHono": {disabled:false, radio:false}, 
    "fechaDesde": {disabled:false, radio:false},
    "fechaHasta": {disabled:false, radio:false}, 
    "siniestro":{disabled:false, radio:true},
    "patente": {disabled:false, radio:true},
    "nroSolicitud": {disabled:false, radio:true}
}

export default function buscarReducer(state , action) {
    switch (action.type) {
        case RESET:
            return { ...state,
                mandante:{...state.mandante, disabled:false},
                origenHono:{...state.origenHono, disabled:false},
                situacionHono:{...state.situacionHono, disabled:false},
                fechaDesde:{...state.fechaDesde, disabled:false},
                fechaHasta:{...state.fechaHasta, disabled:false},
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},
                nroSolicitud:{...state.nroSolicitud, disabled:false}
            }
        case INIT:
            return { ...state,
                mandante:{...state.mandante, disabled:true},
                origenHono:{...state.origenHono, disabled:true},
                situacionHono:{...state.situacionHono, disabled:true},
                fechaDesde:{...state.fechaDesde, disabled:true},
                fechaHasta:{...state.fechaHasta, disabled:true},
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},            
                nroSolicitud:{...state.nroSolicitud, disabled:false}    
            }
        case SET_DISABLED:
            action.payload.name

            return { ...state,[action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]} }
           
        default:
            return state
    }
}